import React from 'react';
import Footer from '../component/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is included

const Female = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Female Urology Care</h1>

        <section className="mb-4">
          <h2>Urinary Incontinence Treatment</h2>
          <p className="text-justify">
            Urinary incontinence is the involuntary leakage of urine, a condition that affects millions of women worldwide.
            It can manifest as stress urinary incontinence, where urine leaks due to increased abdominal pressure from
            activities like sneezing, coughing, or lifting heavy objects, or overactive bladder (OAB), characterized by the
            sudden urge to urinate and potential leakage.
          </p>

          <h4>Stress Urinary Incontinence</h4>
          <p className="text-justify">
            Stress Urinary Incontinence is commonly seen in women after childbirth or due to aging and hormonal changes.
            Treatment options range from pelvic floor exercises and lifestyle modifications to medications and minimally
            invasive surgery, such as Urethral Sling (TVT/TOT) procedures, which provide long-term relief.
          </p>

          <h4>Overactive Bladder</h4>
          <p className="text-justify">
            Overactive Bladder is more prevalent in women of all age groups, leading to discomfort and a significantly
            reduced quality of life. Treatments include medications, lifestyle changes, bladder training, and in some cases,
            surgical interventions for more severe symptoms.
          </p>
        </section>

        <section className="mb-4">
          <h2>Vesico Vaginal Fistula (VVF)</h2>
          <p className="text-justify">
            A Vesico Vaginal Fistula (VVF) is an abnormal opening between the bladder and vagina, often caused by traumatic
            childbirth, surgery, or radiation therapy. This condition results in continuous urine leakage through the vagina,
            causing significant discomfort and social distress.
          </p>
          <p className="text-justify">
            VVF requires prompt medical attention and is primarily treated with surgery to close the fistula. Dr. Aditya Sharma
            specializes in performing minimally invasive surgical repairs to restore normal function and improve quality of life.
          </p>
        </section>

        <section className="mb-4">
          <h2>Vaginal Prolapse</h2>
          <p className="text-justify">
            Vaginal prolapse, also known as vaginal vault prolapse, occurs when the vaginal walls or other pelvic organs descend
            from their normal position due to weakened pelvic muscles. This condition is common in women who have had multiple
            pregnancies, undergone menopause or experienced significant weight gain.
          </p>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Female;
